import {
  ButtonComponent,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { FaImage, FaSuperpowers } from 'react-icons/fa';
import { IoIosArrowForward } from 'react-icons/io';
import { ThemeContext } from '../../context/theme.context';
import Profile from '../../assets/icons/profile/profile.png';
import ProfileLight from '../../assets/icons/profile/profile_.png';
import { toast } from 'react-toastify';
import Cropper from 'react-easy-crop';
import templateFooter from './footer';
import Weather from '../../components/Weather';
interface IProps {
  onClickToggle: () => void;
}
interface IState {
  hideDialog: boolean;
  hideCropDialog: boolean;
  hidePreviewDialog: boolean;
  imageSrc: any;
  crop: any;
  zoom: any;
  aspect: any;
  selectedFile: any | null;
  cropConfig: any;
  imageUrl: any;
  croppedImgUrl: any;
  croppedAreaPixels: any;
  acceptSettings: any;
  currentProfile: any;
  currentPass: any;
  newPass: any;
  confirmPass: any;
  label: any;
  setCount: string;
}

export default class Header extends React.Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private dialogInstance: DialogComponent;
  private animationSettings: AnimationSettingsModel;
  private buttons: ButtonPropsModel[];
  private buttonsCropper: ButtonPropsModel[];
  private imgObj: HTMLImageElement;
  private fileObj: HTMLInputElement;
  private dialogObjCropper: DialogComponent;
  private dialogObjPreview: DialogComponent;
  constructor(prop: IProps) {
    super(prop);
    this.dialogInstance = new DialogComponent(null);
    this.dialogObjCropper = new DialogComponent(null);
    this.dialogObjPreview = new DialogComponent(null);
    this.animationSettings = { effect: 'SlideRight', duration: 500 };
    this.buttonsCropper = [
      {
        click: () => {
          this.setState({ hideCropDialog: false, hideDialog: true });
        },
        buttonModel: {
          isToggle: true,
          content: 'Cancel',
        },
      },
      {
        click: () => {
          this.accept();
        },
        buttonModel: {
          isPrimary: true,
          content: 'Accept',
        },
      },
    ];
    this.buttons = [
      {
        click: () => {
          this.dialogInstance.hide();
          this.save();
        },
        buttonModel: {
          isPrimary: true,
          content: 'Save',
        },
      },
      {
        click: () => {
          this.dialogInstance.hide();
          this.cancel();
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      hideDialog: false,
      imageSrc: '',
      crop: { x: 0, y: 0 },
      zoom: 1,
      aspect: 4 / 4,
      selectedFile: '',
      label: '',
      cropConfig: {
        unit: '%',
        width: 30,
        aspect: 16 / 9,
      },
      imageUrl: '',
      hideCropDialog: false,
      croppedImgUrl: '',
      croppedAreaPixels: '',
      acceptSettings: '',
      currentProfile: 'dark',
      hidePreviewDialog: false,
      confirmPass: '',
      currentPass: '',
      newPass: '',
      setCount: '',
    };

    this.imgObj = document.getElementById('imgContent') as HTMLImageElement;
    this.fileObj = document.getElementById('fileContent') as HTMLInputElement;
  }

  private dialogClose(): void {
    this.setState({ hideDialog: false });
  }
  private dialogOpen(): void {
    this.setState({ hideDialog: true });
  }

  public onChanges(e: any): any {
    this.setState({ imageSrc: URL.createObjectURL(e.target.files[0]) });
    this.setState({ hideCropDialog: true, hideDialog: false });
  }

  openFile = () => {
    this.fileObj.click();
  };
  public onCropChange = (crop: any) => {
    this.setState({ crop });
  };
  public async accept() {
    const cropped = await GetCroppedImage(
      this.state.imageSrc,
      this.state.croppedAreaPixels,
      0
    );
    this.setState({ croppedImgUrl: cropped });
    this.imgObj.src = cropped as unknown as string;
    this.setState({ hideCropDialog: false, hideDialog: true });
  }

  public onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
    this.setState({ croppedAreaPixels });
  };

  public onZoomChange = (zoom: any) => {
    this.setState({ zoom });
  };
  public save() {
    this.setState({ acceptSettings: this.state.croppedImgUrl });
  }
  public cancel() {
    this.setState({ croppedImgUrl: '' });
  }

  public SetIcon(state: any) {
    if (this.state.croppedImgUrl === '') {
      this.setState({ currentProfile: state });
    }
  }
  public openPreviewDialog() {
    if (this.state.croppedImgUrl === '') {
      toast.error("Doesn't exist profile image");
    } else {
      this.setState({ hidePreviewDialog: true, hideDialog: false });
    }
  }
  onCloseEdit() {
    this.setState({ hidePreviewDialog: false, hideDialog: true });
  }
  changePassword() {
    var centerArea = document.getElementById('centerArea');
    var passwordArea = document.getElementById('passArea');
    // centerArea?.classList.remove("centerSettings");
    centerArea?.classList.toggle('centerSettings2');
    passwordArea?.classList.toggle('changePasswordHide');
    passwordArea?.classList.add('changePassword');
  }
  changePreferences() {
    var centerArea = document.getElementById('centerArea');
    var prefArea = document.getElementById('prefArea');
    // centerArea?.classList.remove("centerSettings");
    centerArea?.classList.toggle('centerSettings2');
    prefArea?.classList.toggle('changePasswordHide');
    prefArea?.classList.add('changePassword');
  }
  acceptBtn() {
    // this.setState({ newPass: "", confirmPass: "", currentPass: "" });
    var centerArea = document.getElementById('centerArea');
    var passwordArea = document.getElementById('passArea');
    centerArea?.classList.toggle('centerSettings2');
    passwordArea?.classList.toggle('changePasswordHide');
  }
  cancelBtn() {
    // this.setState({ newPass: "", confirmPass: "", currentPass: "" });
    var centerArea = document.getElementById('centerArea');
    var passwordArea = document.getElementById('passArea');
    centerArea?.classList.toggle('centerSettings2');
    passwordArea?.classList.toggle('changePasswordHide');
  }
  contentSetting() {
    return (
      <div style={{ height: '350px' }}>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                id='imgContent'
                ref={(img) => {
                  this.imgObj = img as HTMLImageElement;
                }}
                src={
                  this.state.croppedImgUrl == ''
                    ? this.state.currentProfile === 'light'
                      ? ProfileLight
                      : Profile
                    : this.state.croppedImgUrl
                }
                style={{
                  height: '90px',
                  width: '90px',
                  backgroundColor: this.context.isDarkMode
                    ? '#15202B'
                    : ' white',

                  borderRadius: 50,
                }}
                onClick={this.openPreviewDialog.bind(this)}
              />
              <div
                style={{
                  padding: 0,
                  flexDirection: 'column',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    fontFamily: 'fantasy',
                    fontSize: '19px',
                    fontStyle: '-moz-initial',
                  }}
                >
                  John Doe
                </div>
                <div
                  style={{
                    fontFamily: 'sans-serif',
                    fontSize: '15px',
                  }}
                >
                  Manager
                </div>
              </div>
            </div>
          </div>
          <div className='seperateElement' />
          <div
            className='centerSettings'
            id='centerArea'
            style={{
              marginLeft: '10px',
              visibility: 'visible',
            }}
          >
            <input
              hidden={true}
              type='file'
              name=''
              id='fileContent'
              ref={(file) => {
                this.fileObj = file as HTMLInputElement;
              }}
              onChange={this.onChanges.bind(this)}
            />
            <div>
              <ButtonComponent
                onClick={this.openFile}
                style={{
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                  height: '40px',
                  width: '200px',
                  marginBottom: '10px',
                }}
              >
                <FaImage size='20px' style={{ marginRight: '5px' }} />
                <p style={{ marginTop: '10px' }}>Select Image</p>
                <IoIosArrowForward
                  size='20px'
                  style={{
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    display: 'flex',
                    marginLeft: '40px',
                  }}
                />
              </ButtonComponent>
              <ButtonComponent
                onClick={this.changePassword.bind(this)}
                style={{
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                  height: '40px',
                  width: '200px',
                }}
              >
                <FaSuperpowers size='20px' style={{ marginRight: '5px' }} />
                <p style={{ marginTop: '10px' }}>Change Password</p>
                <IoIosArrowForward size='20px' style={{ marginLeft: '9px' }} />
              </ButtonComponent>

              <ButtonComponent
                onClick={this.changePreferences.bind(this)}
                style={{
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                  height: '40px',
                  width: '200px',
                  marginTop: '10px',
                }}
              >
                <FaSuperpowers size='20px' style={{ marginRight: '5px' }} />
                <p style={{ marginTop: '10px' }}>Preferences</p>
                <IoIosArrowForward size='20px' style={{ marginLeft: '9px' }} />
              </ButtonComponent>
            </div>
          </div>

          <div id='passArea' className='changePasswordHide'>
            <TextBoxComponent
              type={'password'}
              placeholder='Current Password'
              cssClass='e-outline'
              floatLabelType='Auto'
              showClearButton={true}
              value={this.state.currentPass}
              onChange={(value: any) =>
                this.setState({ currentPass: value.value })
              }
            />
            <TextBoxComponent
              className='e-success'
              type={'password'}
              placeholder='New Password'
              cssClass='e-outline'
              floatLabelType='Auto'
              showClearButton={true}
              value={this.state.newPass}
              onChange={(value: any) => this.setState({ newPass: value.value })}
            />
            <TextBoxComponent
              type={'password'}
              placeholder='Confirm Password'
              cssClass='e-outline'
              floatLabelType='Auto'
              showClearButton={true}
              value={this.state.confirmPass}
              onChange={(value: any) =>
                this.setState({ confirmPass: value.value })
              }
            />
            <div className='col-md-12 passwordButtons'>
              <div className='col-md-6'>
                <ButtonComponent
                  style={{
                    width: '150px',
                    display: 'flex',
                    backgroundColor: 'green',
                  }}
                  onClick={this.acceptBtn.bind(this)}
                >
                  Accept
                </ButtonComponent>
              </div>
              <div className='col-md-6'>
                <ButtonComponent
                  style={{
                    width: '100',
                    backgroundColor: 'red',
                  }}
                  onClick={this.cancelBtn.bind(this)}
                >
                  Cancel
                </ButtonComponent>
              </div>
            </div>
          </div>
          <div id='prefArea' className='changePasswordHide'>
            <h4 style={{ marginTop: '50px', marginBottom: '15px' }}>
              Language Selection :
            </h4>

            <DropDownListComponent
              id='header-dropdown'
              placeholder='Select a language'
              dataSource={['EN-US', 'EN-AUS', 'EN-UK']}
            />

            <h4
              style={{
                marginTop: '15px',
                display: 'inline-block',
                marginRight: '50px',
              }}
            >
              Theme Selection:
            </h4>

            <SwitchComponent
              className='toggle_wrapper'
              id='switch-dark-light'
              style={{ marginTop: '35px' }}
              onLabel={'Dark'}
              offLabel={'Light'}
              enableRtl={true}
              checked={true}
            />
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div className='header-shadow'>
        <div className='header-section dock-menu' id='header'>
          <ul className='header-list' style={{ display: 'flex' }}>
            <div className='firs-child'>
              <li>
                <div
                  className='hamburger-container'
                  onClick={this.props.onClickToggle.bind(this)}
                >
                  <div className='bar1'></div>
                  <div className='bar2'></div>
                  <div className='bar3'></div>
                </div>
              </li>
            </div>

            <div className='second-child'>
              <div className='left-header header-list'></div>
              <div className='left-header header-list'>
                <h4
                  style={{
                    fontWeight: 'bold',
                    marginRight: '0vw',
                    marginTop: '2px',
                    borderRight: '2px solid',
                    paddingRight: '10px',
                  }}
                  className='title-head list'
                >
                  Control Centre
                </h4>
              </div>
              <div className='right-header list weather'>
                <Weather />
              </div>
              {/* <div className='right-header list toggle'>
                <SwitchThemeButton onChangeTheme={this.SetIcon.bind(this)} />
              </div> */}
              <div
                className='right-header list'
                style={{
                  display: 'flex',
                  marginTop: '6.1px',
                }}
              >
                <div className='horizontal-menu'>
                  <img
                    id='dark'
                    src={
                      this.state.acceptSettings == ''
                        ? this.state.currentProfile === 'light'
                          ? ProfileLight
                          : Profile
                        : this.state.acceptSettings
                    }
                    style={{
                      height: '25px',
                      width: '25px',
                      backgroundColor: this.context.isDarkMode
                        ? '#15202B'
                        : 'white',
                      borderRadius: '15px',
                    }}
                    onClick={this.dialogOpen.bind(this)}
                  />
                  <div id='target' className='col-lg-8'>
                    {/* <DialogComponent
                      id='modalDialog'
                      isModal={true}
                      buttons={this.buttons}
                      header='Account Settings'
                      width='400px'
                      height='400px'
                      style={{
                        maxHeight: '550px',
                        backgroundColor: this.context.isDarkMode
                          ? '#15202B'
                          : 'white',
                        height: '100px',
                      }}
                      ref={(dialog) =>
                        (this.dialogInstance = dialog as DialogComponent)
                      }
                      minHeight='550px'
                      cssClass='test123'
                      visible={this.state.hideDialog}
                      open={this.dialogOpen.bind(this)}
                      close={this.dialogClose.bind(this)}
                      animationSettings={this.animationSettings}
                      content={this.contentSetting.bind(this)}
                    ></DialogComponent> */}
                    <DialogComponent
                      isModal={true}
                      buttons={this.buttonsCropper}
                      header='Edit Image'
                      width='500px'
                      height='550px'
                      animationSettings={{
                        effect: 'SlideLeft',
                        duration: 500,
                      }}
                      ref={(dialog) =>
                        (this.dialogObjCropper = dialog as DialogComponent)
                      }
                      visible={this.state.hideCropDialog}
                      open={() => this.setState({ hideCropDialog: true })}
                      close={() => this.setState({ hideCropDialog: false })}
                    >
                      <div
                        style={{
                          width: '470px',
                          height: '400px',
                          position: 'absolute',
                        }}
                      >
                        <Cropper
                          cropShape={'round'}
                          image={this.state.imageSrc}
                          crop={this.state.crop}
                          zoom={this.state.zoom}
                          aspect={this.state.aspect}
                          onCropChange={this.onCropChange}
                          onCropComplete={this.onCropComplete}
                          onZoomChange={this.onZoomChange}
                        />
                      </div>
                    </DialogComponent>
                    <DialogComponent
                      isModal={true}
                      header='Profile Image'
                      width='727px'
                      height='550px'
                      showCloseIcon={true}
                      animationSettings={{
                        effect: 'SlideTop',
                        duration: 500,
                      }}
                      close={this.onCloseEdit.bind(this)}
                      footerTemplate={templateFooter}
                      ref={(dialog) =>
                        (this.dialogObjPreview = dialog as DialogComponent)
                      }
                      visible={this.state.hidePreviewDialog}
                    >
                      <div
                        style={{
                          width: '95%',
                          height: '70%',
                          position: 'absolute',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <img
                          id='imgContent'
                          src={this.state.croppedImgUrl}
                          style={{
                            height: '250px',
                            width: '250px',
                            backgroundColor: this.context.isDarkMode
                              ? '#15202B'
                              : 'white',
                            marginRight: 10,
                            borderRadius: 120,
                          }}
                          onClick={this.openPreviewDialog.bind(this)}
                        />
                      </div>
                    </DialogComponent>
                  </div>
                </div>
              </div>
              <div
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  margin: '0px 10px',
                }}
              >
                <p>{process.env.REACT_APP_ERP_TYPE}</p>
              </div>
            </div>
          </ul>
        </div>
      </div>
    );
  }
}
function GetCroppedImage(imageSrc: any, croppedAreaPixels: any, arg2: number) {
  throw new Error('Function not implemented.');
}
